import { mount } from 'svelte';
import App from './App.svelte';

const dataEl = document.getElementById('intranet-tree');
const target = document.getElementById('intranet-filebrowser');

let data = [];
if (dataEl) {
    try {
        data = JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
        console.error('[intranet] Konnte Tree-JSON nicht parsen:', e);
    }
}

if (target) {
    mount(App, {
        target,
        props: { data },
    });
} else {
    console.warn('[intranet] Mount-Element #intranet-filebrowser nicht gefunden.');
}
